import { Fragment } from "react";
import { FormControl, Typography, Box } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Colors from "assets/Style/Colors";
import { parse } from "date-fns"; // To parse the date string

function DatePicker({
  label,
  value,
  size,
  views,
  openTo,
  error,
  disabled,
  disablePast,
  disableFuture,
  register,
  onChange,
  minDate,
  maxDate,
  bgcolor,
  padding,
}) {
  // Set a fixed minDate as January 1, 2025
  const fixedMinDate = parse("01-01-2025", "dd-MM-yyyy", new Date());

   const resolvedMinDate =
    minDate === false ? undefined : minDate || fixedMinDate;

  return (
    <Fragment>
      <Typography
        variant="body1"
        sx={{ textTransform: "capitalize", color: Colors.charcoalGrey }}
      >
        {label}
      </Typography>
      <FormControl variant="standard" fullWidth sx={{ mb: 1 }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box width="100%">
            <DesktopDatePicker
              openTo={openTo}
              views={views}
              format="dd-MM-yyyy"
              disabled={disabled}
              disablePast={disablePast}
              disableFuture={disableFuture}
              value={value ?? null}
              minDate={resolvedMinDate} // Use the fixed min date here
              maxDate={maxDate}
              onChange={onChange}
              sx={{
                width: 1, // width: 100% of parent Box
                backgroundColor: bgcolor,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                },
              }}
              slotProps={{
                textField: {
                  fullWidth: true, // ✅ key change for full width
                  size: size,
                  error,
                  ...register,
                  sx: {
                    mt: 1,
                    backgroundColor: bgcolor,
                    borderRadius: "12px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: "45px",
                      alignItems: "center",
                      paddingLeft: "12px",
                      paddingRight: "12px",
                    },
                    "& .MuiInputBase-input": {
                      height: "auto",
                      boxSizing: "border-box",
                      padding: padding ? padding : "10px 0",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputAdornment-root": {
                      marginTop: 0,
                    },
                  },
                },
                field: { clearable: true },
              }}
            />
          </Box>
        </LocalizationProvider>
        {error && (
          <Typography color="error" sx={{ fontSize: 12, textAlign: "left" }}>
            {error}
          </Typography>
        )}
      </FormControl>
    </Fragment>
  );
}

export default DatePicker;
